<script>
    import { getFlameLinkReadingMaterials } from "../../services/flamelink";
    import ArticleBlock from '../ArticleBlock.svelte';

    $: articles = [];
    export let selectedWeek;

    getFlameLinkReadingMaterials().then(data => {
        Object.keys(data).map(key => {
            const cms = data[key]
            const forWeek = cms.forChallenge.weekNumber;
            const title = cms.title;
            const thumbnail = cms.thumbnail[0].url;
            const subtitle = cms.subtitle;
            const link = cms.linkToContent;
            
            articles = [...articles, {
                forWeek,
                title,
                thumbnail,
                subtitle,
                link,
                orderToAppear: cms.orderToAppear
            }]
        })
    })


</script>

<style>

    .reading_material_grid_container {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        row-gap: 70px;
        padding-bottom: 70px;
        max-width: 500px;
    }



    .no_hover {
        color: white !important;
        text-decoration: none;
    }
    .no_hover:hover {
        color: white !important;
        text-decoration: none;
    }

    .no_hover:visited {
        color: white !important;
        text-decoration: none;
    }
</style>


{#if articles.length != 0}
{#if selectedWeek != ''}
<h1 class="header_text" style="margin-top: 40px; margin-bottom: 15px;">REQUIRED READING <br/>AND VIEWING</h1>
<div class="reading_material_grid_container">
    {#each articles.filter(x => x.forWeek == selectedWeek.weekNumber).sort((a,b) => a.orderToAppear - b.orderToAppear) as article, i}


    {#if article.link != ''}
        <a class="no_hover" href={article.link} target="_blank">
            <ArticleBlock article={article} />
        </a>
    {/if}

    {#if article.link == ''}
            <ArticleBlock article={article} />
    {/if}


    {/each}
</div>
{/if}
{/if}